import request from '@/utils/request'

// 1. 账号分页查询（后端：POST /user/page，请求体传参）
export const getAccountPage = (queryDTO) => {
  return request({
    url: '/api/user/page', // 后端路径：/user/page
    method: 'POST', // 后端是@PostMapping，必须用POST
    data: queryDTO, // 参数放请求体（后端@RequestBody接收）
    headers: {
      // 后端需要请求头username（登录用户名），从localStorage获取
      'username': JSON.parse(localStorage.getItem('userInfo'))?.username || ''
    }
  })
}

// 2. 新增账号（后端：POST /user/add，请求体+请求头）
export const addAccount = (addDTO) => {
  return request({
    url: '/api/user/add', // 后端路径：/user/add
    method: 'POST',
    data: addDTO,
    headers: {
      'username': JSON.parse(localStorage.getItem('userInfo'))?.username || ''
    }
  })
}

// 3. 编辑账号（后端：PUT /user/update，请求体+请求头）
export const updateAccount = (updateDTO) => {
  return request({
    url: '/api/user/update', // 后端路径：/user/update
    method: 'PUT', // 后端是@PutMapping，必须用PUT
    data: updateDTO,
    headers: {
      'username': JSON.parse(localStorage.getItem('userInfo'))?.username || ''
    }
  })
}

// 4. 按ID查询账号（后端：GET /user/{id}，路径参数）
export const getAccountById = (id) => {
  return request({
    url: `/api/user/${id}`, // 后端路径：/user/{id}（路径参数）
    method: 'GET' // 后端是@GetMapping
  })
}

// 5. 删除账号（后端无此接口！先隐藏按钮，或让后端新增）
export const deleteAccount = (id) => {
  return request({
    url: `/api/user/delete/${id}`,
    method: 'DELETE',
    headers: {
      'username': JSON.parse(localStorage.getItem('userInfo'))?.username || ''
    }
  })
}